module.exports = __webpack_public_path__ + "img/2.7a8ebb89.jpg";